import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ElementRef } from '@angular/core';
import { SaleItem } from '../../../data/sale-item';
import { upperCaseValue, getValue, takeUntilDestroyed } from 'projects/core/src/public-api';
import moment from 'moment';
import { timer, merge } from 'rxjs';
import { QBService } from '../../../data/qb.service';
import { QBClass } from '../../../data/qb-class';
import { QBServ } from '../../../data/qb-serv';
import { SelectItem } from 'primeng/api';
import { ProjectSale } from '../../../data/project-sale';

class TableColumnDef {
    field: string
    header: string
    type?: 'Date' | 'number' | 'user'
    renderer?: any
    class?: string
}

class TempSale {
    qty?: string;
    unitPrice?: string;
    classId?: string;
    productId?: string;
}

@Component({
    selector: 'app-sale-lines',
    templateUrl: './sale-lines.component.html',
    styleUrls: ['./sale-lines.component.scss']
})
export class SaleLinesComponent implements OnInit, OnDestroy {

    @Input()
    items: SaleItem[];

    @Input()
    qbServClasses = [];

    @Input()
    baseQbServClasses = [];

    cols: TableColumnDef[];

    qbClasses: SelectItem[];

    qbServs: SelectItem[];

    queue = [];

    tempItem: TempSale;

    @Output()
    updateAfterSave = new EventEmitter<void>();

    constructor(
        protected qbService: QBService,
        protected el: ElementRef
    ) { }

    ngOnInit(): void {
        if (this.items[this.items.length - 2]) {
            // tslint:disable-next-line: radix
            this.queue.push(parseInt(this.items[this.items.length - 2].id) + 1)
        }

        this.cols = [
            { field: 'id', header: '#', class: 'hash' },
            { field: 'salesItemLineDetail.itemRef.value', header: 'PRODUCT/SERVICE', renderer: upperCaseValue, class: 'product' },
            { field: 'description', header: 'DESCRIPTION', class: 'description' },
            { field: 'salesItemLineDetail.classRef.value', header: 'CLASS', renderer: upperCaseValue, class: 'product' },
            { field: 'salesItemLineDetail.qty', header: 'QTY', class: 'quantity' },
            { field: 'salesItemLineDetail.unitPrice', header: 'RATE', class: 'rate' },
            { field: 'amount', header: 'AMOUNT', class: 'amount' },
            { field: 'amount', header: '', class: 'delete' }
        ];

        this.qbClasses = this.qbServClasses[0];
        this.qbServs = this.qbServClasses[1];
        // this.getClassesAndServices();

    }

    // getClassesAndServices() {
    // 	merge(this.qbService.getQBClasses(), this.qbService.getQBServices())
    // 		.pipe(
    // 			takeUntil(this.getUnsubFromAllSubs())
    // 		)
    // 		.subscribe(result => {
    // 			console.log(result)
    // 		})
    // }

    getFieldData(rowData: any, col: TableColumnDef) {
        let value = getValue(rowData, col.field)
        if (col.type === 'Date') {
            value = moment(value).format('ll');
        }
        else if (col.type === 'number') {
            value = Math.round(value * 100) / 100
        }

        if (col.renderer) {
            value = col.renderer(value)
        }
        // if col has renderer, then apply this renderer to value

        return value
    }

    addLines() {
        let temp
        if (this.items[this.items.length - 1] && typeof this.items[this.items.length - 1].id === 'undefined') {
            temp = this.items.pop();
        }


        this.queue.sort((a, b) => a - b);
        let tempId = this.queue.shift();

        if (this.queue.length === 0) {
            this.queue.push(tempId + 1);
        }

        tempId += ''

        const tempItem = {
            id: tempId,
            description: `Manufacture and deliver cabinetry per proposal`,
            amount: 0,
            salesItemLineDetail: {
                itemRef: {
                    name: `Fabrication (retailing)`
                },
                qty: 1,
                unitPrice: 0
            },
            detailType: 'SALES_ITEM_LINE_DETAIL'
        } as SaleItem

        if (this.items.length > 0) {
            const lastItem = this.items[0]
            if (lastItem.salesItemLineDetail && lastItem.salesItemLineDetail.classRef) {
                tempItem.salesItemLineDetail.classRef = lastItem.salesItemLineDetail.classRef
            }

        }

        this.items.push(tempItem)

        if (temp && temp.amount) {
            this.items.push(temp)
        }
    }

    updateTotal(event) {
        const fItem = this.items.find(it => it.id === event.index)

        if (fItem?.salesItemLineDetail) {
            fItem.amount = fItem.salesItemLineDetail.qty * fItem.salesItemLineDetail.unitPrice
        }


        const newTempSale = new TempSale();

        if (fItem?.salesItemLineDetail) {
            newTempSale.qty = fItem.salesItemLineDetail.qty.toString()
            newTempSale.unitPrice = fItem.salesItemLineDetail.unitPrice.toString();


            if (newTempSale.unitPrice !== this.tempItem.unitPrice || newTempSale.qty !== this.tempItem.qty) {
                this.updateAfterSave.emit();
            }
        }

    }

    startEdit(event) {
        const temp = this.items.find(it => it.id === event.index)

        this.tempItem = new TempSale();

        if (temp?.salesItemLineDetail) {
            this.tempItem.qty = temp.salesItemLineDetail.qty.toString()
            this.tempItem.unitPrice = temp.salesItemLineDetail.unitPrice.toString()
        }

        if (event.field === 'salesItemLineDetail.qty' || event.field === 'salesItemLineDetail.unitPrice') {

            const tempInputs = (this.el.nativeElement as HTMLInputElement).getElementsByClassName('material-input-text');
            if (tempInputs) {
                timer(1).subscribe(emit => {
                    const input = tempInputs[0] as HTMLInputElement
                    input.focus()
                    input.setSelectionRange(0, input.value.length);
                })
            }
        }
    }

    deleteLine(idToDelete: string) {
        const index = this.items.findIndex(it => it.id === idToDelete)
        if (index > -1) {
            // tslint:disable-next-line: radix
            this.queue.push(parseInt(this.items[index].id));
            this.items.splice(index, 1);
        }

    }

    textAreaAdjust(element) {
        // (element.srcElement as HTMLElement).style.height = ((element.srcElement as HTMLElement).scrollTop) + 'px';
    }

    servChanged(sale: SaleItem) {
        const fItem = (this.baseQbServClasses[1] as QBServ[]).find(ser => ser.fullyQualifiedName === sale.salesItemLineDetail.itemRef.name);
        if (fItem) {
            sale.description = fItem.description;
            // sale.salesItemLineDetail.itemRef.value = fItem.id
        }

        this.updateAfterSave.emit();
    }

    classChanged(sale: SaleItem) {
        const fItem = (this.baseQbServClasses[0] as QBClass[]).find(cls => cls.fullyQualifiedName === sale.salesItemLineDetail.classRef.name);
        if (fItem) {
            sale.salesItemLineDetail.classRef.name = fItem.fullyQualifiedName;
            sale.salesItemLineDetail.classRef.value = fItem.id
        }

        this.updateAfterSave.emit();

        return fItem.name
    }

    ngOnDestroy() {

    }
}
